import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import styles from './VideoContainer.module.scss';
import { useTranslation } from 'react-i18next';

type VideoSearchResultProps = {
  searchTerm: string;
  filteredByKeyWordLists: { [key: string]: vp.VideoObject };
  getSelectedVideo: (video: vp.VideoObject) => void;
};

type FC = FunctionComponent<VideoSearchResultProps>;

const { Box } = vp;

const VideoSearchResult: FC = (props: VideoSearchResultProps) => {
  const { searchTerm, filteredByKeyWordLists, getSelectedVideo } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'LearningCentre.VideoTutorials' });

  return (
    <Box flx="col" gap="md">
      <div className={styles.searchResults}>
        <i>{t('resultsCount', { count: Object.values(filteredByKeyWordLists).length, searchTerm })}</i>
      </div>
      <Box flx="col" gap="ml">
        {Object.values(filteredByKeyWordLists).length > 0 ? (
          <>
            {Object.values(filteredByKeyWordLists).map((video, index) => {
              const title = video.title;
              const lowerSearchTerm = searchTerm.toLowerCase();
              const indexOfMatch = title.toLowerCase().indexOf(lowerSearchTerm);

              if (indexOfMatch !== -1) {
                const beforeMatch = title.substring(0, indexOfMatch);
                const match = title.substring(indexOfMatch, indexOfMatch + lowerSearchTerm.length);
                const afterMatch = title.substring(indexOfMatch + lowerSearchTerm.length);

                return (
                  <div
                    key={index}
                    className={styles.searchResultCard}
                    onClick={() => {
                      getSelectedVideo(video);
                    }}
                  >
                    <div className={styles.label}>{video.category}</div>
                    <div className={styles.title}>
                      {beforeMatch}
                      <strong>{match}</strong>
                      {afterMatch}
                    </div>
                  </div>
                );
              }
              return <></>;
            })}
          </>
        ) : (
          <div className={styles.message}>{t('noResults')}</div>
        )}
      </Box>
    </Box>
  );
};

export default VideoSearchResult;
